module.exports = __webpack_public_path__ + "img/vol05_cup02_label04.adab5276.png";